export default [
  {
    name: 'companyInformation',
    label: 'labels.companyInformation',
    permissionKey: 'company_information',
    children: [
      {
        name: 'company_edit',
        label: 'labels.companyEdit',
        permissionKey: 'company_edit'
      }
    ]
  },
  {
    name: 'companyGroup',
    label: 'labels.companyGroupManagement',
    permissionKey: 'company_group_management',
    children: [
      {
        name: 'company_group_add',
        label: 'labels.companyGroupAdd',
        permissionKey: 'company_group_add'
      },
      {
        name: 'company_group_edit',
        label: 'labels.companyGroupEdit',
        permissionKey: 'company_group_edit'
      },
      {
        name: 'company_group_update_permissions',
        label: 'labels.companyGroupUpdatePermissions',
        permissionKey: 'company_group_update_permissions'
      },
      {
        name: 'company_group_delete',
        label: 'labels.companyGroupDelete',
        permissionKey: 'company_group_delete'
      },
      {
        name: 'company_group_archive',
        label: 'labels.companyGroupArchive',
        permissionKey: 'company_group_archive'
      }
    ]
  },
  {
    name: 'companyUser',
    label: 'labels.companyUserManagement',
    permissionKey: 'company_user_management',
    children: [
      {
        name: 'company_user_edit',
        label: 'labels.companyUserEdit',
        permissionKey: 'company_user_edit'
      },
      {
        name: 'company_user_add',
        label: 'labels.companyUserAdd',
        permissionKey: 'company_user_add'
      },
      {
        name: 'company_user_delete',
        label: 'labels.companyUserDelete',
        permissionKey: 'company_user_delete'
      },
      {
        name: 'company_user_archive',
        label: 'labels.companyUserArchive',
        permissionKey: 'company_user_archive'
      }
    ]
  },
  {
    name: 'connectManagement',
    label: 'labels.connectManagement',
    permissionKey: 'connect_management',
    children: [
      {
        name: 'connect_add',
        label: 'labels.createConnect',
        permissionKey: 'connect_add'
      },
      {
        name: 'connect_delete',
        label: 'labels.deleteConnect',
        permissionKey: 'connect_delete'
      }
    ]
  }
]
